const themeNameLight = 'light';
const themeNameDefault = themeNameLight;
const themeNames = [themeNameLight, 'light-mobile', 'light-high-contrast-experimental', 'dark-experimental'];

export { themeNameDefault, themeNameLight, themeNames };
